const environments = {
    development: {
        //开发
        baseURL: 'http://192.168.1.177:1211',
        uploadBaseUrl: 'http://192.168.1.177:1211/upload/single',
        multiUploadBaseUrl: "http://192.168.1.177:1211/upload/batch",
        fileUrl: 'https://img2.9000ji.com',
        wsUrl: 'ws://192.168.1.176:1234/ws-biz',

        //开发2
        // baseURL: 'http://192.168.1.19:1211',
        // uploadBaseUrl: 'http://192.168.1.19:1211/upload/single',
        // multiUploadBaseUrl: "http://192.168.1.19:1211/upload/batch",
        // fileUrl: 'https://img2.9000ji.com',
        // wsUrl: 'ws://192.168.1.19:1234/ws-biz',
        
        //测试2
        // baseURL: 'http://192.168.1.183:1211',
        // uploadBaseUrl: 'http://192.168.1.183:1211/upload/single',
        // multiUploadBaseUrl: "http://192.168.1.183:1211/upload/batch",
        // fileUrl: 'https://img2.9000ji.com',
        // wsUrl: 'wss://testsocket.fanxingtiaodong.cn/ws-biz',

        //测试1
        // baseURL: 'http://bakgateway.btstars.cn',
        // uploadBaseUrl: 'http://bakgateway.btstars.cn/upload/single',
        // multiUploadBaseUrl: "http://bakgateway.btstars.cn/upload/batch",
        // fileUrl: 'https://img2.9000ji.com',
        // wsUrl: 'wss://testsocket.fanxingtiaodong.cn/ws-biz',
        
        //预发布
        // baseURL: 'http://pregateway.fanxingtiaodong.com',
        // uploadBaseUrl: 'http://pregateway.fanxingtiaodong.com/upload/single',
        // multiUploadBaseUrl: "http://pregateway.fanxingtiaodong.com/upload/batch",
        // fileUrl: 'https://img2.9000ji.com',
        // wsUrl: 'wss://presocket.fanxingtiaodong.cn/ws-biz',
    },
    // 开发1环境
    testing: {
        baseURL: 'http://192.168.1.177:1211',
        uploadBaseUrl: 'http://192.168.1.177:1211/upload/single',
        multiUploadBaseUrl: "http://192.168.1.177:1211/upload/batch",
        fileUrl: 'https://img2.9000ji.com',
        wsUrl: 'wss://testsocket.fanxingtiaodong.cn/ws-biz',
    },
    // 开发2环境
    developmentTwo: {
        baseURL: 'http://192.168.1.19:1211',
        uploadBaseUrl: 'http://192.168.1.19:1211/upload/single',
        multiUploadBaseUrl: "http://192.168.1.19:1211/upload/batch",
        fileUrl: 'https://img2.9000ji.com',
        wsUrl: 'ws://192.168.1.19:1234/ws-biz',
    },
    //测试2环境
    testingtwo: {
        baseURL: 'http://192.168.1.183:1211',
        uploadBaseUrl: 'http://192.168.1.183:1211/upload/single',
        multiUploadBaseUrl: "http://192.168.1.183:1211/upload/batch",
        fileUrl: 'https://img2.9000ji.com',
        wsUrl: 'wss://testsocket.fanxingtiaodong.cn/ws-biz',
    },
    //测试1环境
    release: {
        baseURL: 'http://bakgateway.btstars.cn',
        uploadBaseUrl: 'http://bakgateway.btstars.cn/upload/single',
        multiUploadBaseUrl: "http://bakgateway.btstars.cn/upload/batch",
        fileUrl: 'https://img2.9000ji.com',
        wsUrl: 'wss://testsocket.fanxingtiaodong.cn/ws-biz',
    },
    //预发布
    prerelease: {
        baseURL: 'http://pregateway.fanxingtiaodong.com',
        uploadBaseUrl: 'http://pregateway.fanxingtiaodong.com/upload/single',
        multiUploadBaseUrl: "http://pregateway.fanxingtiaodong.com/upload/batch",
        fileUrl: 'https://img2.9000ji.com',
        wsUrl: 'wss://presocket.fanxingtiaodong.cn/ws-biz',
    },
    //线上
    production: {
        baseURL: 'https://gateway.xylbh.cn',
        uploadBaseUrl: 'https://gateway.xylbh.cn/upload/single',
        multiUploadBaseUrl: "https://gateway.xylbh.cn/upload/batch",
        fileUrl: 'https://img2.9000ji.com',
        wsUrl: 'wss://communicate.xylbh.cn/ws-biz',
    }
};
export default environments

